<template>
  <div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Loading',
  data () {
    return {
      selected: 'Month'
    }
  },
  created () {
    $('.loading').show()
    if (!localStorage.token) {
      this.$router.push({ path: 'login' })
    } else {
      this.$router.push({ path: 'dashboard' })
    }
  }
}
</script>
